module.exports = require('./helpers/bundle-url').getBundleURL('eW1DW') + "logo.c51670a8.svg";